/**
 * PredictionAccuracyCard — «البوابة قبل النشر» 2026-10-13 (بند 3 من أمر
 * إكمال الجولة C): دقّة prediction_log لكل مستوى ثقة، آخر 30 يوماً، وعدد
 * التنبؤات المقيَّمة — بدل الرقم الثابت «~48%» الذي كان في تبويب «الزوار
 * المتوقعون». إن كان العدد المقيَّم أقل من حدّ الإعدادات (cm_prediction_
 * accuracy_min_evaluated)، يُعرض «لا تكفي التنبؤات المقيَّمة بعد» لا رقماً
 * مضلِّلاً على عيّنة صغيرة.
 */
import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

const CONF_LABELS = { "عالية": "ثقة عالية", "متوسطة": "ثقة متوسطة", "منخفضة": "ثقة منخفضة" };

export function PredictionAccuracyCard() {
  const [state, setState] = useState({ loading: true, err: null, data: null });

  useEffect(() => {
    let cancelled = false;
    api.get("/customer-metrics/prediction-accuracy", { params: { window_days: 30 } })
      .then((r) => { if (!cancelled) setState({ loading: false, err: null, data: r.data }); })
      .catch((e) => { if (!cancelled) setState({ loading: false, err: e?.response?.data?.detail || "تعذّر تحميل دقة التنبؤ", data: null }); });
    return () => { cancelled = true; };
  }, []);

  const { loading, err, data } = state;

  return (
    <div data-testid="prediction-accuracy-card" dir="rtl"
         style={{ background: "#fff", border: "1px solid rgba(15,118,110,0.20)",
                  borderRadius: 16, padding: "16px 20px", marginBottom: 16,
                  boxShadow: "0 1px 3px rgba(15,118,110,0.06)" }}>
      <div style={{ fontSize: 16, fontWeight: 800, color: "#3D2A1C", marginBottom: 6 }}>
        دقة التنبؤ بالزيارة (آخر {data?.window_days ?? 30} يوماً)
      </div>

      {loading && <div data-testid="prediction-accuracy-loading" style={{ fontSize: 12, color: "#78716C" }}>جارٍ التحميل…</div>}
      {err && <div data-testid="prediction-accuracy-error" style={{ fontSize: 12, color: "#B45309" }}>{err}</div>}

      {!loading && !err && data && !data.enough_data && (
        <div data-testid="prediction-accuracy-insufficient" style={{ fontSize: 13, color: "#78716C" }}>
          لا تكفي التنبؤات المقيَّمة بعد ({data.total_evaluated.toLocaleString("en-US")} من {Math.max(data.min_evaluated_to_display, data.total_logged).toLocaleString("en-US")})
        </div>
      )}

      {!loading && !err && data && data.enough_data && (
        <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
          {data.levels.map((lvl) => (
            <div key={lvl.confidence} data-testid={`prediction-accuracy-level-${lvl.confidence}`}
                 style={{ minWidth: 140 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: "#065F46" }}>
                {CONF_LABELS[lvl.confidence] || lvl.confidence}
              </div>
              <div style={{ fontSize: 24, fontWeight: 900, color: "#0F766E",
                             fontVariantNumeric: "lining-nums tabular-nums" }}>
                {lvl.accuracy_pct != null ? `${lvl.accuracy_pct}%` : "—"}
              </div>
              <div style={{ fontSize: 11, color: "#A8A29E" }}>
                {lvl.evaluated.toLocaleString("en-US")} تنبؤ مقيَّم
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default PredictionAccuracyCard;
